import { SET_DEVELOPER_TOOLS_ENABLED } from "./types";

export const setDeveloperToolsEnabled = (enabled: boolean) => {
    return {
        type: SET_DEVELOPER_TOOLS_ENABLED,
        enabled,
    };
};
